export default __webpack_public_path__ + "static/media/login-illustration.39a64f78.svg";